import WeatherMapSelect from '../../../../components/WeatherMapSelect/WeatherMapSelect';
import { useMemo } from 'react';
import { HURRICANES_ALL_LIVE_STORMS_OPTION } from '../../config/hurricanes.config';
import { getStormDisplayLabel } from '../../utils/hurricanes.utils';

const StormSelector = ({
  stormGroups = [],
  selectedStormKey,
  onSelectStorm,
  includeAllOption,
  label = 'Storm',
  className = 'hurricanes-storm-select w-100',
}) => {
  const stormOptions = useMemo(
    () => [
      ...(includeAllOption ? [HURRICANES_ALL_LIVE_STORMS_OPTION] : []),
      ...stormGroups.map((storm) => ({
        value: storm.key,
        label: getStormDisplayLabel(storm),
      })),
    ],
    [includeAllOption, stormGroups],
  );

  if (!stormGroups.length) {
    return (
      <span className="hurricanes-data-status small" role="status">
        No storms found.
      </span>
    );
  }

  return (
    <WeatherMapSelect
      options={stormOptions}
      selectedValue={selectedStormKey}
      onChange={onSelectStorm}
      wrapperClassName={className}
      label={label}
      ariaLabel={label ? undefined : 'Storm'}
      placeholder="Search storms"
      noOptionsMessage="No storms found"
    />
  );
};

export default StormSelector;
